<div
  [style]="containerStyle"
  [style.top]="reportSection.top"
  [style.left]="reportSection.left"
  [style.width]="reportSection.width"
  [style.height]="reportSection.height"
>
  <div [ngStyle]="getStyle()" (click)="onClick($event)"></div>
</div>
